import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Button,
  Select,
  Box
} from '@chakra-ui/react';
import { CategoryType } from '../Table/MaintenanceCategoryTable';
import { UpdateCategoriesApi } from '../../../../apis/UpdateMaintenance.api';
import {
  BanInputType,
  CustomStringInput
} from '../../../atoms/CustomStringInput';
import { CategorySendMessageType } from '../../../constants/MaintenanceConstants';

interface ResponseType {
  success: boolean;
  data: CategoryType[] | null;
  message: unknown | null;
}

interface props {
  isOpen: boolean;
  onClose: () => void;
  EditData: CategoryType | undefined;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<CategoryType[] | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const GetCategoryNameInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 300, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 300, BanInputType: BanInputType.None, Value: addData };
};

const CategoryEditWindow: React.FC<props> = (props) => {
  const {
    isOpen,
    onClose,
    EditData,
    setMaintenanceDatas,
    CreateOrUpdateStateSwitch
  } = props;
  const [categoryName, setCategoryName] = useState(EditData?.name);
  const [categoryType, setCategoryType] = useState(EditData?.type);

  const PostApi = async () => {
    if (EditData !== undefined && EditData.id !== undefined) {
      const response: ResponseType = await UpdateCategoriesApi(EditData.id, {
        name: categoryName,
        type: categoryType
      });
      if (response?.success === false) {
        alert('編集に失敗しました。');
        return;
      }
      setMaintenanceDatas(response.data as CategoryType[]);
      CreateOrUpdateStateSwitch();
      onClose();
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='260px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            カテゴリを編集
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>カテゴリ名</Text>
              <CustomStringInput
                CheckInfo={GetCategoryNameInputCheckData(
                  EditData?.name?.toString()
                )}
                inputValue={categoryName}
                setValue={setCategoryName}
                PhohibitionCharaCheck={false}
              />

              <Text mt={4}>タイプ</Text>
              <Select
                mt={2}
                value={categoryType}
                onChange={(e) => setCategoryType(e.target.value)}
              >
                <option value={CategorySendMessageType.Signage}>
                  停留場メッセージ
                </option>
                <option value={CategorySendMessageType.Obc}>
                  OBCメッセージ
                </option>
                <option value={CategorySendMessageType.Location}>
                  位置情報メッセージ
                </option>
                <option value={CategorySendMessageType.Message}>
                  共通メッセージ
                </option>
              </Select>
            </Box>
            <Button
              mt={10}
              onClick={() => {
                PostApi();
              }}
            >
              更新
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(CategoryEditWindow);
